(() => {
    "use strict";

    angular
        .module("app")
        .filter("stDate", stDateFilter);

    function stDateFilter($filter) {
        return input => $filter("date")(input, "MM/dd/yyyy");
    }
    stDateFilter.$inject = ["$filter"];

})()